<template>

  <div class="group" :ref="refs[builder.config.fieldName + 'Group']">

    <div class="group-header" :id="`${builder.config.fieldName}Title`">
    <div class="group-title">Choose your interior.</div>
    <div class="group-help">The below options are based on the measurements you have provided.</div>
    </div>

    <Selector
    :key=builder.config.fieldName
    :field-name=builder.config.fieldName
    :display-type=builder.config.displayType
    :options=builder.config.options
    :selected=builder.currentSection[builder.config.fieldName]
    options-source="interiorOptionsForSection"
    scope="section"
    @select-option="select"
    ></Selector>

  </div>
  
</template>

<script setup>
  
import { ref, computed } from 'vue'

import { useBuilderStore } from "@/stores/builder";
const builder = useBuilderStore();

import { useLightboxStore } from "@/stores/lightbox";
const lightbox = useLightboxStore();

function selectGroup(prop, opt) {
  builder.setCurrentSectionSpec(prop, opt['id']);
  if (builder.configOptionsForConfigGroup.length >= 1) {
    builder.setCurrentSectionSpec(builder.config.fieldName, builder.configOptionsForConfigGroup[0]['id']);
  } else {
    builder.setCurrentSectionSpec(builder.config.fieldName, opt['id']);
  }
}

function select(prop, opt) {
  builder.setCurrentSectionSpec(prop, opt['id']);
}

function viewInfo(opt) {
  console.log(opt);
  let infoHtml = builder.currentSectionConfigDescription;
  console.log(infoHtml);
  lightbox.open(infoHtml);
}

// init refs
let refHandles = [
  builder.config.fieldName + 'Group',
  builder.config.fieldName + 'SubGroup',
];
const refs = _.chain(refHandles).keyBy().mapValues(ref).value();
refHandles.forEach(item => {
  builder.refs[item] = refs[item];
});
</script>